<div>
    <div class="breadcrumb-block">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <a class="breadcrumb-item" aria-current="page">Home</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Dashboard</li>
            </ol>
        </nav>
    </div>
    <div class="dashboard-block">
        <div class="">
             <div class="row">
            <div class="col-md-3">
                <div class="white-box pb-0">
                    <div class="info-card">
                        <div class="info-card-header">
                            <div class="row">
                                <div class="col-lg-4">
                                    <div class="card-icon">
                                        <i class="fas fa-clipboard-check"></i>
                                    </div>
                                </div>
                                <div class="col-lg-8">
                                    <div class="info-card-title">
                                        <p>Total bookings</p>
                                        <h1>300</h1>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        <div class="time-stamp">
                            <p><i class="far fa-clock"></i> Last updated 5mins ago</p>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-md-3">
                <div class="white-box pb-0">
                    <div class="info-card">
                        <div class="info-card-header">
                            <div class="row">
                                <div class="col-lg-4">
                                    <div class="card-icon">
                                        <i class="fas fa-check-double"></i>
                                    </div>
                                </div>
                                <div class="col-lg-8">
                                    <div class="info-card-title">
                                        <p>Total pre-bookings</p>
                                        <h1>1270</h1>
                                    </div>
                                </div>
                            </div>



                        </div>
                        <div class="time-stamp">
                                <p><i class="far fa-clock"></i> Last updated 5mins ago</p>
                            </div>
                    </div>

                </div>
            </div>
            <div class="col-md-3">
                <div class="white-box pb-0">
                    <div class="info-card">
                        <div class="info-card-header">
                            <div class="row">
                                <div class="col-lg-4">
                                    <div class="card-icon">
                                        <i class="fas fa-user"></i>
                                    </div>
                                </div>
                                <div class="col-lg-8">
                                    <div class="info-card-title">
                                        <p>Total clients</p>
                                        <h1>1305</h1>
                                    </div>
                                </div>
                            </div>



                        </div>
                        <div class="time-stamp">
                                <p><i class="far fa-clock"></i> Last updated 5mins ago</p>
                            </div>
                    </div>

                </div>
            </div>
            <div class="col-md-3">
                <div class="white-box pb-0">
                    <div class="info-card">
                        <div class="info-card-header">
                            <div class="row">
                                <div class="col-lg-4">
                                    <div class="card-icon">
                                        <i class="fas fa-chart-bar"></i>
                                    </div>
                                </div>
                                <div class="col-lg-8">
                                    <div class="info-card-title">
                                        <p>Total package</p>
                                        <h1>42</h1>
                                    </div>


                                </div>
                            </div>



                        </div>
                        <div class="time-stamp">
                                <p><i class="far fa-clock"></i> Last updated 5mins ago</p>
                            </div>
                    </div>

                </div>
            </div>
        </div>
        </div>
       
        <div class="row">
            <div class="col-lg-9">
                <div class="stats-1 white-box mt-5">
                    <div class="row">
                        <div class="col-lg-6">
                                <div class="table-title">
                                        <h5>booking stats</h5>
                                </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="text-lg-right mr-3">
                                    <label for="">View stats on basis of:</label>
                                    <select>
                                        <option value="volvo">Package</option>
                                        <option value="saab">Price</option>
                                    </select>
                            </div>
                        </div>
                    </div>
                    
                    <canvas id="myChart"></canvas>
                </div>
                <div class="white-box mt-5">
                        <div class="row">
                                <div class="col-lg-6">
                                        <div class="table-title">
                                                <h5>Top 5 selling package</h5>
                                        </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="text-lg-right mr-3">
                                            <label for="">View stats on basis of:</label>
                                            <select>
                                                <option value="volvo">Month</option>
                                                <option value="saab">Year</option>
                                            </select>
                                    </div>
                                </div>
                        </div>
                        <div class="bar-2">
                                <canvas id="myChart-2"></canvas>
                        </div>
                    </div>
            </div>
            <div class="col-lg-3">
                <div class="white-box mt-5">
                        <div class="table-title text-lg-center">
                                <h5>booking status</h5>
                        </div>
                    <canvas id="myChart-1"></canvas>
                </div>

                <div class="white-box mt-5">
                        <div class="table-title text-lg-center">
                          
                            <h5>Package sales growth</h5>
                        </div>
                       <div class="sales-block">
                            <p>Today</p> 
                            <h5>Rs.50,000 (<i class="fas fa-arrow-up"></i>  4.5%)</h5>
                            
                            <p>(Last month: Rs.55,000)</p>
                       </div>
                       <hr>
                       <div class="sales-block sales-block-decrease">
                            <p>This week</p> 
                            <h5>Rs.1,00,000 (<i class="fas fa-arrow-down"></i>  4.5%)</h5>
                            
                            <p>(Last month: Rs.1,50,000)</p>
                       </div>
                       <hr>
                       <div class="sales-block">
                            <p>This month</p> 
                            <h5>Rs.1,50,000 (<i class="fas fa-arrow-up"></i>  4.5%)</h5>
                            
                            <p>(Last month: Rs.1,00,000)</p>
                       </div>
                       <hr>
                       <div class="sales-block">
                            <p>This year</p> 
                            <h5>Rs.12,50,000 (<i class="fas fa-arrow-up"></i>  4.5%)</h5>
                            
                            <p>(Last month: Rs.12,00,000)</p>
                       </div>
                </div>
                
            </div>
        </div>

        
                
        
      
      
        <div class="row">
            <div class="col-lg-7">
                    <div class="white-box mt-5">
                            <div class="table-title">
                                <h5>recent booking</h5>
                            </div>
                            <div class="table-container recent-activity">
                                <div class="table-responsive">
                                    <table id="example" class="table">
                                        <thead class="table-light-bg">
                                            <tr>
                                                <th scope="col">Id</th>
                                                <th scope="col">Package Name
                                                </th>
                                                <th>Price($)</th>
                                                <th>Booked by</th>
                                                <th>No.of people</th>
                                                <th>Country</th>
                                                <th>Departure date</th>
                                               
                                            </tr>
                                        </thead>
                                        <tbody class="align-top">
                                            <tr>
                                                <td>
                                                   1
                                                </td>
                                                <td>
                                                    <div class="activity-description">
                                                            <p>Annapurna Base Camp Trek</p>
                                                    </div>
                                                </td>
                                                <td>
                                                    750.00
                                                </td>
                                                <td>
                                                    <div class="activity-description">
                                                        <p>Paul Scholes</p>
                                                    </div>
                                                </td>
                                               <td><span class="badge badge-success">10</span></td>
                                               <td>England</td>
                                               
                                                <td>
                                                        <div class="activity-description">
                                                                <p>18-08-2019</p>
                                                            </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                    <td>
                                                      2
                                                    </td>
                                                    <td>
                                                        <div class="activity-description">
                                                                <p>Annapurna Base Camp Trek</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        750.00
                                                    </td>
                                                    <td>
                                                        <div class="activity-description">
                                                            <p>Paul Scholes</p>
                                                        </div>
                                                    </td>
                                                    <td><span class="badge badge-success">10</span></td>
                                                    <td>England</td>
                                                    <td>
                                                            <div class="activity-description">
                                                                    <p>18-08-2019</p>
                                                                </div>
                                                    </td>
                                            </tr>
                                            <tr>
                                                    <td>
                                                      3
                                                    </td>
                                                    <td>
                                                        <div class="activity-description">
                                                                <p>Annapurna Base Camp Trek</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        750.00
                                                    </td>
                                                    <td>
                                                        <div class="activity-description">
                                                            <p>Paul Scholes</p>
                                                        </div>
                                                    </td>
                                                    <td><span class="badge badge-success">10</span></td>
                                                    <td>England</td>
                                                    <td>
                                                            <div class="activity-description">
                                                                    <p>18-08-2019</p>
                                                                </div>
                                                    </td>
                                            </tr>
                                            <tr>
                                                    <td>
                                                      4
                                                    </td>
                                                    <td>
                                                        <div class="activity-description">
                                                                <p>Annapurna Base Camp Trek</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        750.00
                                                    </td>
                                                    <td>
                                                        <div class="activity-description">
                                                            <p>Paul Scholes</p>
                                                        </div>
                                                    </td>
                                                    <td><span class="badge badge-success">10</span></td>
                                                    <td>England</td>
                                                    <td>
                                                            <div class="activity-description">
                                                                    <p>18-08-2019</p>
                                                                </div>
                                                    </td>
                                            </tr>
                                            <tr>
                                                    <td>
                                                    5
                                                    </td>
                                                    <td>
                                                        <div class="activity-description">
                                                                <p>Annapurna Base Camp Trek</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        750.00
                                                    </td>
                                                    <td>
                                                        <div class="activity-description">
                                                            <p>Paul Scholes</p>
                                                        </div>
                                                    </td>
                                                    <td><span class="badge badge-success">10</span></td>
                                                    <td>England</td>
                                                    <td>
                                                            <div class="activity-description">
                                                                    <p>18-08-2019</p>
                                                                </div>
                                                    </td>
                                            </tr>
                                            <tr>
                                                    <td>
                                                      6
                                                    </td>
                                                    <td>
                                                        <div class="activity-description">
                                                                <p>Annapurna Base Camp Trek</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        750.00
                                                    </td>
                                                    <td>
                                                        <div class="activity-description">
                                                            <p>Paul Scholes</p>
                                                        </div>
                                                    </td>
                                                    <td><span class="badge badge-success">10</span></td>
                                                    <td>England</td>
                                                    <td>
                                                            <div class="activity-description">
                                                                    <p>18-08-2019</p>
                                                                </div>
                                                    </td>
                                            </tr>
                                            <tr>
                                                    <td>
                                                      7
                                                    </td>
                                                    <td>
                                                        <div class="activity-description">
                                                                <p>Annapurna Base Camp Trek</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        750.00
                                                    </td>
                                                    <td>
                                                        <div class="activity-description">
                                                            <p>Paul Scholes</p>
                                                        </div>
                                                    </td>
                                                    <td><span class="badge badge-success">10</span></td>
                                                    <td>England</td>
                                                    <td>
                                                            <div class="activity-description">
                                                                    <p>18-08-2019</p>
                                                                </div>
                                                    </td>
                                            </tr>
                                            <tr>
                                                    <td>
                                                      8
                                                    </td>
                                                    <td>
                                                        <div class="activity-description">
                                                                <p>Annapurna Base Camp Trek</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        750.00
                                                    </td>
                                                    <td>
                                                        <div class="activity-description">
                                                            <p>Paul Scholes</p>
                                                        </div>
                                                    </td>
                                                    <td><span class="badge badge-success">10</span></td>
                                                    <td>England</td>
                                                    <td>
                                                            <div class="activity-description">
                                                                    <p>18-08-2019</p>
                                                                </div>
                                                    </td>
                                            </tr>
                                            <tr>
                                                    <td>
                                                    9
                                                    </td>
                                                    <td>
                                                        <div class="activity-description">
                                                                <p>Annapurna Base Camp Trek</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        750.00
                                                    </td>
                                                    <td>
                                                        <div class="activity-description">
                                                            <p>Paul Scholes</p>
                                                        </div>
                                                    </td>
                                                    <td><span class="badge badge-success">10</span></td>
                                                    <td>England</td>
                                                    <td>
                                                            <div class="activity-description">
                                                                    <p>18-08-2019</p>
                                                                </div>
                                                    </td>
                                            </tr>
                                            <tr>
                                                    <td>
                                                     10
                                                    </td>
                                                    <td>
                                                        <div class="activity-description">
                                                                <p>Annapurna Base Camp Trek</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        750.00
                                                    </td>
                                                    <td>
                                                        <div class="activity-description">
                                                            <p>Paul Scholes</p>
                                                        </div>
                                                    </td>
                                                    <td><span class="badge badge-success">10</span></td>
                                                    <td>England</td>
                                                    <td>
                                                            <div class="activity-description">
                                                                    <p>18-08-2019</p>
                                                                </div>
                                                    </td>
                                            </tr>
                                            
                                        </tbody>
                                    </table>
                                    <!---->
                                </div>
                            </div>
                    </div>
            </div>
            <div class="col-lg-5">
                       

                        <div class="white-box mt-5">
                            <div class="table-title">
                                <h5>Upcoming departure</h5>
                            </div>
                            <div class="table-container recent-activity">
                                <div class="table-responsive">
                                    <table id="example" class="table">
                                        <thead class="table-light-bg">
                                            <tr>
                                                <th scope="col">Id</th>
                                                <th scope="col">Package name
                                                </th>
                                                <th>Departure date</th>
                                                <th>remaining days</th>
                                            
                                            
                                            </tr>
                                        </thead>
                                        <tbody class="align-top">
                                            <tr>
                                                


                                            
                                                <td>
                                                1
                                                </td>
                                                <td>
                                                    <div class="activity-description">
                                                        <p>Annapurna Base Camp Trek</p>
                                                    </div>
                                                </td>
                                                <td>
                                                12-08-2019
                                                </td>
                                                <td>
                                                    <span class="badge badge-primary">21</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                


                                            
                                                <td>
                                                2
                                                </td>
                                                <td>
                                                    <div class="activity-description">
                                                        <p>Ghorepani-Poonhill Trek</p>
                                                    </div>
                                                </td>
                                                <td>
                                                13-08-2019
                                                </td>
                                                <td>
                                                    <span class="badge badge-success">10</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                


                                            
                                                <td>
                                                3
                                                </td>
                                                <td>
                                                    <div class="activity-description">
                                                        <p>Everest Base Camp Trek</p>
                                                    </div>
                                                </td>
                                                <td>
                                                12-08-2019
                                                </td>
                                                <td>
                                                    <span class="badge badge-primary">5</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                


                                            
                                                <td>
                                                4
                                                </td>
                                                <td>
                                                    <div class="activity-description">
                                                        <p>Everest Base Camp Trek</p>
                                                    </div>
                                                </td>
                                                <td>
                                                12-08-2019
                                                </td>
                                                <td>
                                                    <span class="badge badge-primary">5</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                


                                            
                                                <td>
                                                5
                                                </td>
                                                <td>
                                                    <div class="activity-description">
                                                        <p>Everest Base Camp Trek</p>
                                                    </div>
                                                </td>
                                                <td>
                                                12-08-2019
                                                </td>
                                                <td>
                                                    <span class="badge badge-primary">5</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                


                                            
                                                    <td>
                                                    1
                                                    </td>
                                                    <td>
                                                        <div class="activity-description">
                                                            <p>Annapurna Base Camp Trek</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                    12-08-2019
                                                    </td>
                                                    <td>
                                                        <span class="badge badge-primary">21</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    
    
    
                                                
                                                    <td>
                                                    2
                                                    </td>
                                                    <td>
                                                        <div class="activity-description">
                                                            <p>Ghorepani-Poonhill Trek</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                    13-08-2019
                                                    </td>
                                                    <td>
                                                        <span class="badge badge-success">10</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    
    
    
                                                
                                                    <td>
                                                    3
                                                    </td>
                                                    <td>
                                                        <div class="activity-description">
                                                            <p>Everest Base Camp Trek</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                    12-08-2019
                                                    </td>
                                                    <td>
                                                        <span class="badge badge-primary">5</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    
    
    
                                                
                                                    <td>
                                                    4
                                                    </td>
                                                    <td>
                                                        <div class="activity-description">
                                                            <p>Everest Base Camp Trek</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                    12-08-2019
                                                    </td>
                                                    <td>
                                                        <span class="badge badge-primary">5</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    
    
    
                                                
                                                    <td>
                                                    5
                                                    </td>
                                                    <td>
                                                        <div class="activity-description">
                                                            <p>Everest Base Camp Trek</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                    12-08-2019
                                                    </td>
                                                    <td>
                                                        <span class="badge badge-primary">5</span>
                                                    </td>
                                                </tr>
                                            
                                        
                                        </tbody>
                                    </table>
                                    <!---->
                                </div>
                            </div>
                        </div>
            </div>
        </div>
    </div>
</div>